require('./Button_Broadcasting.scss');
require('../../Icon/Icon.scss');
require('../../Icon/_Play/_Size/Icon_Play_Size_S.scss');
require('../../Icon/_Play/_Size/Icon_Play_Size_M.scss');
require('../../Icon/_Play/_Size/Icon_Play_Size_L.scss');

const _merge = require('lodash/merge');
const React = require('react');
const ReactDOM = require('react-dom');
const PropTypes = require('prop-types');
const {connect} = require('react-redux');

const _get = require('lodash/get');
const nextTick = require('app/www/libs/nextTick');

const {withReq} = require('app/www/components/contexts/Req');
const {withI18n} = require('app/www/components/contexts/I18n');

const Global = require('app/www/components/blocks/Global/Global');
const Ua = require('app/www/components/blocks/Ua/Ua');
const Button = require('app/www/components/blocks/Button/Button');
const ButtonWrapper = require('app/www/components/blocks/ButtonWrapper/ButtonWrapper');
const Stream = require('app/www/components/blocks/Stream/Stream');
const Tooltip = require('app/www/components/blocks/Tooltip/Tooltip');
const Metrika = require('app/www/libs/client/metrika');
const {getStreamDefaultChannel} = require('app/common/libs/streamChannel');

const TOOLTIP = require('app/www/constants/tooltip');
const {
    EFIR_URL,
    DEFAULT_CHANNEL_FAMILY_ID,
    DEFAULT_CHANNEL_TRANSLITERATED,
} = require('app/common/constants/stream');

class Button_Broadcasting extends React.PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            tooltip: false,
            stream: false,
            streamChannel: false,
        };

        this._onClick = this._onClick.bind(this);
        this._onMouseEnter = this._onMouseEnter.bind(this);
        this._onMouseLeave = this._onMouseLeave.bind(this);
        this._openTooltip = this._openTooltip.bind(this);
        this._onCloseStream = this._onCloseStream.bind(this);
    }

    componentDidMount() {
        const {
            channelId,
            location,
            notSendMetrika,
        } = this.props;

        if (location !== 'recommended' && !notSendMetrika) {
            Metrika.trackParams('ONLINE_POPUP', {
                channelId,
                location,
                action: 'show',
                isStream: Boolean(this._streamChannel),
            });
        }
    }

    componentDidUpdate() {
        const {
            familyId,
            streamChannel,
            streamChannels,
            familyIdFromStore,
        } = this.props;

        const currentFamilyId = familyId || familyIdFromStore;
        const currentChannel = streamChannels.filter(stream => currentFamilyId === stream.familyId)[0]
            || getStreamDefaultChannel(streamChannels);

        this.setState({
            streamChannel: streamChannel || currentChannel,
        });
    }

    render() {
        if (!Global.isRussia || Ua.isOldOpera || Ua.isOldIE) {
            return null;
        }

        const {
            req,
            i18n,
            mods,
            icon,
            from,
            expflags,
            tooltipProps,
            children,
            location,
            streamActive,
            notUpdateMeta,
            changeHistory,
            streamLocation,
            titleFromStore,
            transliteratedFamilyTitle,
        } = this.props;

        const {
            stream,
            streamChannel,
        } = this.state;

        const urlBuilder = req.lib('urlBuilder');

        const buttonWrapperProps = {
            mods: {
                touch: mods.touch,
                broadcasting: true,
                active: this.state.stream,
            },
        };

        const text = streamLocation === 'channelpage'
            ? i18n.get('button.broadcasting.channel-header')
            : children || i18n.get('button.broadcasting.value');

        let transliteratedTitle = transliteratedFamilyTitle || titleFromStore;

        if (streamChannel && streamChannel.familyId === DEFAULT_CHANNEL_FAMILY_ID) {
            transliteratedTitle = DEFAULT_CHANNEL_TRANSLITERATED;
        }

        const buttonProps = _merge({}, this.props, {
            url: !titleFromStore && location === 'header' ? EFIR_URL : urlBuilder.getStreamUrl(transliteratedTitle),
            onMouseEnter: this._onMouseEnter,
            onMouseLeave: this._onMouseLeave,
            onClick: this._onClick,
            mods: {
                broadcasting: true,
            },
            attrs: {
                title: i18n.get('button.broadcasting.online-channel', {
                    channelName: streamChannel ? streamChannel.title : '',
                }),
                target: '_blank',
            },
            children: text,
        });

        if (icon) {
            buttonProps.icon = Object.assign({play: true}, icon);
        }

        if ((!this.props.attrs || !this.props.attrs.title) && location !== 'header') {
            buttonProps.attrs = {
                title: i18n.get('button.broadcasting.online-channel', {
                    channelName: streamChannel ? streamChannel.title : '',
                }),
            };
        }

        const streamProps = {
            from,
            expflags,
            changeHistory,
            streamActive,
            updateMeta: !notUpdateMeta,
            channel: streamChannel,
            fromBlock: this.props.streamLocation || location,
            onClose: this._onCloseStream,
            transliteratedFamilyTitle: transliteratedTitle,
        };

        return (
            <ButtonWrapper {...buttonWrapperProps}>
                <Button
                    ref={ref => (this.button = ref)}
                    {...buttonProps}
                />
                {this.state.tooltip && (
                    <Tooltip
                        ref={ref => (this.tooltip = ref)}
                        owner={this.button.node}
                        {...tooltipProps}
                    >
                        {i18n.get('button.broadcasting.tooltip')}
                    </Tooltip>
                )}
                {(stream && streamChannel) && (
                    ReactDOM.createPortal(
                        <Stream {...streamProps} />,
                        this._streamContainer
                    )
                )}
            </ButtonWrapper>
        );
    }

    _onClick(evt) {
        const {
            channelId,
            programId,
            location,
            onClick,
            titleFromStore,
            notSendMetrika,
        } = this.props;

        let trackParamsAction = 'LINK_EFIR';

        if (titleFromStore || location !== 'header') {
            evt.preventDefault();

            this._streamContainer = document.createElement('div');
            document.body.appendChild(this._streamContainer);

            this.setState({
                stream: true,
            });

            this._closeTooltip();

            onClick(evt);

            trackParamsAction = 'ONLINE_POPUP';
        }

        if (!notSendMetrika) {
            Metrika.trackParams(trackParamsAction, {
                channelId,
                programId,
                location,
                action: 'click',
                isStream: Boolean(this.state.streamChannel),
            });
        }
    }

    _onMouseEnter() {
        if (this.props.tooltipProps) {
            this._timeout = setTimeout(this._openTooltip, TOOLTIP.DELAY);
        }
    }

    _onMouseLeave() {
        if (this.props.tooltipProps) {
            clearTimeout(this._timeout);
            this._closeTooltip();
        }
    }

    _openTooltip() {
        this.setState({tooltip: true});

        nextTick(() => this.tooltip.open());
    }

    _closeTooltip() {
        if (this.tooltip) {
            this.tooltip.close();
        }
    }

    _onCloseStream() {
        this.setState({
            stream: false,
        }, () => {
            document.body.removeChild(this._streamContainer);
        });
    }

}

Button_Broadcasting.defaultProps = {
    mods: {},
    tooltipProps: {
        mods: {
            theme: 'normal',
            size: 's',
        },
        to: 'top',
        isAdaptive: true,
    },
    onClick: () => {},
};

Button_Broadcasting.propTypes = {
    channelId: PropTypes.number,
    familyId: PropTypes.number,
    programId: PropTypes.number,
    tooltipProps: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.shape({
            mods: Tooltip.propTypes.mods,
            to: PropTypes.string,
            isAdaptive: PropTypes.bool,
        }),
    ]),
    mods: Button.propTypes.mods,
    icon: PropTypes.shape({
        play: PropTypes.bool,
        size: PropTypes.string,
    }),
    location: PropTypes.string,
    streamChannel: PropTypes.object,
    streamActive: PropTypes.string,
    changeHistory: PropTypes.bool,
    notUpdateMeta: PropTypes.bool,
    streamLocation: PropTypes.string,
    onClick: PropTypes.func,
    notSendMetrika: PropTypes.bool,
    expflags: PropTypes.string,
    transliteratedFamilyTitle: PropTypes.string,
};

function mapStateToProps(state) {
    return {
        streamChannels: state.streamChannels,
        familyIdFromStore: _get(state, 'channel.channel.familyId'),
        titleFromStore: _get(state, 'channel.channel.transliteratedFamilyTitle'),
    };
}

module.exports = connect(
    mapStateToProps,
    null,
    null,
    {
        withRef: true,
    }
)(
    withReq(withI18n(
        Button_Broadcasting
    ))
);
